import { computed } from '@vue/composition-api';

import { cloneDeep } from 'lodash-es';
import { walkTreeBFS, getIdItemMap } from '@tt4b/ttam-utils';
import store from './store';
const { state } = store;
export function useInterest() {
  const interestCategoriesInfoMap = computed(() => {
    const map = {};
    walkTreeBFS({
      root: { children: cloneDeep(state.interestList.value) },
      handler: node => {
        map[node.id] = node;
        node.keyword_id = node.id;
        node.keyword = node.i18n_value;
      },
    });

    return map;
  });
  const interestOptions = computed(() => state.interestList.value.map(({ id }) => interestCategoriesInfoMap.value[id]));
  const interestItemMap = computed(() => getIdItemMap(interestOptions.value));

  return {
    interestItemMap,
  };
}
